import { useEffect, useRef, useState } from "react";
import BIService from "services/bi";

const bi = new BIService();

const useBISource = (dashboardId) => {
  const [isLoading, setIsLoading] = useState(true);
  const source = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    bi.getSource({ dashboardId })
      .then(data => {
        if (!data) return;
        source.current = data;
      })
      .catch(() => {
        source.current = null;
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, [dashboardId]);

  return { isLoading, source: source.current };
};

export default useBISource;